import { create } from "zustand";

const isUpdateCookieStore = create((set) => ({
  isUpdateCookie: false,
  setIsUpdateCookie: (newValue) =>
    set((state) => ({
      isUpdateCookie: newValue
    }))
}));

export default isUpdateCookieStore;
